import React, { useEffect, useState } from "react";
import client from "../../assets/images/Ellipse 1.png";
import axios from "axios";
import { useParams } from "react-router-dom";
import "../SharedModule/SideOrderDetails.css";
import { useSelector } from "react-redux";

export default function SideOrderDetails() {

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const baseUrl = "https://estbn.com/EstbnNew/public";

  const [order, setOrder] = useState([]);

  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);

  const toggleOrderModal = () => {
    setIsOrderModalOpen(!isOrderModalOpen);
  };

  const { id } = useParams();

  const getOrder = async () => {
    try {
      let response = await axios.get(`${baseUrl}/api/portal/orders/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data.data.order);
      setOrder(response.data.data.order);
    } catch (error) {
      console.log(error.message);
    }
  };

const modifyDate = (date) => {
  if (!date) return "-";

  const formatted = date.replace(" at ", " ");

  const d = new Date(formatted);

  if (isNaN(d)) return "-";

  return d.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
 
  useEffect(() => {
    getOrder();
  }, [id]);

  return (
    <>
      {isOrderModalOpen && (
        <div
          className="modal fade show"
          id="exampleModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden={isOrderModalOpen ? "false" : "true"}
          // aria-hidden="true"
          style={{ display: "block" }}
        >
          <div
            className="modal-dialog orderDetails-modal"
            // style={{ maxWidth: "50%" }}
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header orderDetails-modalHeader px-4">
                <p
                  className="modal-title orderDetails-modalTitle mx-3 fs-3 text-muted fw-semibold "
                  id="exampleModalLabel"
                >
                  Order
                  <span className=" fs-3 mx-2 fw-bolder text-dark">#145</span>
                </p>
                <i
                  className="fa-regular fa-clock fa-xl ms-2"
                  style={{ color: "blueviolet" }}
                ></i>
                <p className="my-0 mx-2 fs-5 text-muted fw-semibold">
                  Executing
                </p>
              </div>
              <div className="modal-body orderDetails-modalBody px-3 py-2">
                <div className=" d-flex justify-content-between align-items-center my-2">
                  <div className="w-50 mx-2">
                    <label className=" fw-semibold" htmlFor="">
                      Requested Date
                    </label>
                    <input type="date" className="form-control my-2" />
                  </div>
                  <div className="w-50 mx-2">
                    <label className=" fw-semibold" htmlFor="Time">
                      Time
                    </label>
                    <select
                      className="form-select my-2"
                      aria-label="Default select example"
                      id="Time"
                    >
                      <option selected>Select Time</option>
                      <option value="1">09:00 am 12:00 pm</option>
                      <option value="2">12:00 pm 03:00 pm</option>
                      <option value="3">03:00 pm 06:00 pm</option>
                      <option value="3">06:00 pm 09:00 pm</option>
                    </select>
                  </div>
                </div>
                <div className="m-2">
                  <div>
                    <label className=" fw-semibold" htmlFor="location">
                      Location
                    </label>
                    <input
                      type="text"
                      className=" form-control my-2"
                      placeholder="Enter location"
                      id="location"
                    />
                  </div>
                </div>
                <div className="my-3 mx-2">
                  <div className="overflow-hidden rounded-2">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d161458.96358337457!2d31.487165312378934!3d30.00529577757057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2seg!4v1735571701502!5m2!1sen!2seg"
                      width="1000"
                      height="200"
                      allowfullscreen
                      loading="lazy"
                      title="Responsive Google Map"
                    ></iframe>
                  </div>
                </div>
                <div className="form-group mx-2">
                  <label for="comment" className="fw-semibold">
                    Comments
                  </label>
                  <textarea
                    className="form-control my-2"
                    rows="5"
                    placeholder="Write client comments"
                    id="comment"
                  ></textarea>
                </div>
              </div>
              <div className="modal-footer d-flex justify-content-evenly">
                <button
                  type="button"
                  className="btn btn-dark  px-5  fs-5  "
                  onClick={toggleOrderModal}
                  style={{ width: "35%" }}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-outline-dark px-5 fs-5  "
                  onClick={toggleOrderModal}
                  style={{ width: "35%" }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="col-sm-12 col-md-4">
        <div className="order-data border border-1 rounded-2 px-3 py-4 ms-sm-0 my-sm-3 my-md-0 ms-md-2 small">
          <p className="fw-bolder fs-4">Order #{order.id}</p>
          <div className="services-card d-flex justify-content-between align-items-center">
            <div>
              <p className="my-0">Services:</p>
            </div>
            <div className="services-icons d-flex">
              {order.categories?.map((cat) => {
                return (
                  <img
                    key={cat.id}
                    src={
                      cat.icon_url?.startsWith("http")
                        ? cat.icon_url
                        : `${baseUrl}${cat.icon_url}`
                    }
                    style={{ width: "35px" }}
                    alt=""
                  />
                );
              })}
            </div>
          </div>
          <div className="d-flex justify-content-between order-nested-data">
            <p>Order Date:</p>
            <span>{modifyDate(order.ordered_at)}</span>
          </div>
          <div className=" d-flex justify-content-between order-nested-data">
            <p>Updated Date:</p>
            <span>{modifyDate(order.updated_at)}</span>
          </div>
          <div className=" d-flex justify-content-between order-nested-data">
            <p>Car Model:</p>
            <span>{order.vehicle?.name}</span>
          </div>
          <hr />
          <div className="d-flex justify-content-between align-items-center">
            <p className="fw-semibold">Order Info</p>
            <div className="services-icons">
              <i className="fa-regular fa-comment-dots fs-5 mx-3"></i>
              <i
                onClick={toggleOrderModal}
                className="fa-solid fa-pen fs-5 cursor"
              ></i>
            </div>
          </div>
          <div className="d-flex justify-content-between  order-nested-data">
            <p>Requested Date:</p>
            <span>{modifyDate(order.created_at)}</span>
          </div>
          <div className="d-flex justify-content-between  order-nested-data">
            <p>Time:</p>
            <span>
              From {order.scheduled_from} To {order.scheduled_to}
            </span>
          </div>
          <div className="d-flex justify-content-between  order-nested-data">
            <p>Payment:</p>
            <span>{order.payment?.method?.name_en}</span>
          </div>
          <div className="d-flex justify-content-between  order-nested-data">
            <p>Location:</p>
            <span>{order.address?.area}</span>
          </div>
          <div className="d-flex justify-content-between  order-nested-data">
            <p>latitude:</p>
            <span>{order.address?.latitude}</span>
          </div>
          <div className="d-flex justify-content-between  order-nested-data">
            <p>longitude:</p>
            <span>{order.address?.longitude}</span>
          </div>
        </div>
        <div className="client-data border border-1 rounded-2 px-3 py-4 ms-sm-0 ms-md-2 mt-4 small">
          <p className=" fs-5 fw-semibold my-2">Client</p>
          <div className=" d-flex justify-content-between align-items-center">
            <div className=" d-flex justify-content-between ">
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  minHeight: "50px",
                  minWidth: "50px",
                  borderRadius: "50%",
                }}
                className="mt-1 overflow-hidden"
              >
                <img
                  style={{
                    width: "50px",
                    height: "50px",
                    minHeight: "50px",
                    minWidth: "50px",
                    borderRadius: "50%",
                  }}
                  className="object-fit-cover"
                  src={
                    order?.user?.profile_photo_path
                      ? `${baseUrl}${order.user.profile_photo_path}`
                      : client
                  }
                  onError={(e) => {
                    e.currentTarget.src = client;
                  }}
                  alt=""
                />
              </div>
              <div className=" mx-2">
                <p className="my-0 fs-6 fw-medium">{order.user?.name}</p>
                <p className=" client-birthdate text-muted fs-6">
                  <i className="fa-solid fa-cake-candles me-1"></i>
                  {order.user?.birthdate}
                </p>
              </div>
            </div>
            <div>
              <i className="fa-solid fa-chevron-right"></i>
            </div>
          </div>
          <p className=" fs-5 fw-semibold my-2">Client Info</p>
          <div className=" client-info-data">
            <p>
              <i className="fa-solid fa-phone me-2 text-muted"></i>
              {order.user?.phone_number}
            </p>
            <p>
              <i className="fa-regular fa-envelope me-2 text-muted"></i>
              {order.user?.email}
            </p>
            <p>
              <i className="fa-solid fa-car me-2 text-muted"></i>
              {order?.user?.vehicles_count} Vehicles
            </p>
            <p>
              <i className="fa-solid fa-circle me-2 text-success"></i>
              Last activity : {modifyDate(order.user?.last_activity)}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
